<template>
  <v-container v-if="equipmentProfile && equipmentProfile.plant" class="my-12">
    <material-card icon="mdi-pencil" color="primary" inline class="px-5 py-3">
      <template v-slot:after-heading>
        <div class="title text-no-wrap font-weight-light">
          {{ $t("equipmentProfile.equipment") }}
          {{ equipmentProfile.equipTag }}
        </div>
      </template>
      <v-form>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                readonly=""
                v-model="equipmentProfile.plant.name"
                :label="$t('newEquipment.plant')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                readonly=""
                v-model="equipmentProfile.area.name"
                :label="$t('newEquipment.area')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                readonly=""
                v-model="equipmentProfile.unit.name"
                :label="$t('newEquipment.unit')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                v-model="equipmentProfile.location[0]"
                label="Latitud"
              ></v-text-field>

              <v-text-field
                v-model="equipmentProfile.location[1]"
                label="Longitud"
              ></v-text-field>
            </v-col>
            <!--  <v-col cols="12" sm="6" justify="center" align="center">
              <v-select
                filled
                :readonly="!$store.getters['auth/equipmentWrite']"
                :value="equipmentProfile.sealTypes"
                v-model="equipmentProfile.sealTypes"
                item-text="name"
                item-value="name"
                :label="$t('equipmentProfile.sealTypes')"
                :items="sealTypes"
              ></v-select>
            </v-col> -->
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-select
                :readonly="!$store.getters['auth/equipmentWrite']"
                filled
                v-model="equipmentProfile.hazardous"
                :label="$t('equipmentProfile.hazardous')"
                :items="hazardous"
                item-text="name"
                item-value="value"
              ></v-select>
            </v-col>

            <!-- <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                :readonly="!$store.getters['auth/equipmentWrite']"
                filled
                :label="$t('equipmentProfile.mechanical')"
                v-model="equipmentProfile.mechanicalSealCode"
              ></v-text-field>
            </v-col> -->
            <!-- 
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-select
                filled
                :readonly="!$store.getters['auth/equipmentWrite']"
                v-model="equipmentProfile.contract"
                :label="$t('equipmentProfile.typeContract')"
                :items="contract"
                item-text="name"
                item-value="name"
              ></v-select>
            </v-col> -->

            <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                filled
                v-model="equipmentProfile.createdBy"
                :label="$t('equipmentProfile.createdBy')"
                readonly=""
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                filled
                v-model="dateFixed"
                :label="$t('equipmentProfile.dateCreated')"
                readonly=""
              ></v-text-field> </v-col
            ><!-- <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                filled
                v-model="equipmentProfile.product"
                :label="$t('equipmentProfile.product')"
                :readonly="!$store.getters['auth/equipmentWrite']"
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                filled
                v-model="equipmentProfile.manufacturer"
                :label="$t('equipmentProfile.manufacturer')"
                :readonly="!$store.getters['auth/equipmentWrite']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-text-field
                filled
                v-model="equipmentProfile.model"
                :label="$t('equipmentProfile.model')"
                :readonly="!$store.getters['auth/equipmentWrite']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" justify="center" align="center">
              <v-subheader class="pa-0">{{
                $t("equipmentProfile.responsible")
              }}</v-subheader>
              <v-autocomplete
                v-model="equipmentProfile.responsables"
                :items="users"
                multiple=""
                chips
                small-chips
                persistent-hint
                item-value="email"
                :item-text="usuario"
                item-color="success"
                prepend-icon="mdi-database-search"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" justify="center" align="center">
              <v-textarea
                filled
                v-model="equipmentProfile.comment"
                :label="$t('equipmentProfile.comment')"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="$router.back()"
            absolute=""
            bottom=""
            left=""
            fab
            color="error"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <!--  <v-btn
            :disabled="!$store.getters['auth/adminAndUp']"
            color="orange darken-4"
            :x-large="$vuetify.breakpoint.mdAndUp"
            class="my-2 "
            @click="desactivarItem()"
            >Delete</v-btn
          > -->
          <v-spacer></v-spacer>
          <v-btn
            width="200"
            rounded=""
            :x-large="$vuetify.breakpoint.mdAndUp"
            v-if="$store.getters['auth/adminAndUp']"
            color="success"
            class="my-2"
            @click.prevent="submit()"
            >{{ $t("equipmentProfile.updatebtn") }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </material-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  data: () => ({
    metaInfo() {
      return {
        status: this.status
      };
    },
    unitRules: [v => !!v || "Unit is required"],
    areaRules: [v => !!v || "Area is required"],
    plantRules: [v => !!v || "Plant is required"],
    disabledAreas: true,
    disabledUnits: true,
    clientRules: [v => !!v || "Customer is required"],
    contract: [{ name: "Type A" }, { name: "Type B" }],
    status: []
  }),
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch(
      "equipments/bindAnEquipment",
      this.$route.params.id
    );
    await this.$store.dispatch("users/bindUsers");
    loading.close();
    this.status = [
      {
        name: this.$t("reliability.statuslights.running"),
        color: "#008450",
        value: 1
      },
      {
        name: this.$t("reliability.statuslights.standby"),
        color: "#EFB700",
        value: 2
      },
      {
        name: this.$t("reliability.statuslights.maintenance"),
        color: "#DA530A",
        value: 3
      },
      {
        name: this.$t("reliability.statuslights.failure"),
        color: "#B81D13",
        value: 4
      }
    ];
  },
  components: {
    "material-card": () => import("@/components/MaterialCard.vue")
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("users", ["users"]),
    ...mapState("auth", ["user"]),
    ...mapState("settings", [
      "equipmentType",
      "hazardous",
      "sealTypes",
      "plants",
      "areas",
      "units"
    ]),

    dateFixed() {
      if (this.equipmentProfile && this.equipmentProfile.dateCreated) {
        if (this.$root.$i18n.locale === "es") {
          return moment
            .unix(this.equipmentProfile.dateCreated.seconds)
            .locale("es")
            .format("MMMM D YYYY, h:mm:ss a");
        } else {
          return moment
            .unix(this.equipmentProfile.dateCreated.seconds)
            .format("MMMM D YYYY, h:mm:ss a");
        }
      } else {
        return null;
      }
    },
    isPump() {
      return this.equipmentProfile.isPump;
    }
  },

  methods: {
    usuario(item) {
      let name = `${item.firstName} ${item.lastName}`;
      let email = item.email;
      return ` ${name} [${email}]`;
    },
    async submit() {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });

      let payload = {
        db: "equipments",
        doc: this.equipmentProfile.id,
        data: this.equipmentProfile
      };
      await this.$store.dispatch("updateDocument", payload);
      this.$dialog.notify.success("Update done!", {
        position: "top-right",
        timeout: 5000,
        icon: "mdi-update"
      });
      loading.close();
    }
  }
};
</script>

<style></style>
